(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carben-editorial-page"]) return;
  try {
    
(() => {
  function initializeCarbenEditorial(root) {
    const form = root.querySelector('[data-carben-guide-search]');
    if (form && !form.dataset.initialized) {
      form.dataset.initialized = 'true';
      const input = form.querySelector('input[type="search"]');
      const cards = [...root.querySelectorAll('[data-carben-guide-card]')];
      const tabs = [...root.querySelectorAll('[data-carben-guide-kind]')];
      const params = new URLSearchParams(location.search);
      let selected = ['guias', 'manuales', 'videos'].includes(params.get('tipo')) ? params.get('tipo') : 'guias';
      input.value = (params.get('q') || '').slice(0, 80);
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('es-MX');
      const apply = updateUrl => {
        const term = normalize(input.value.trim());
        let count = 0;
        cards.forEach(card => {
          const matches = normalize(card.textContent).includes(term) && (selected !== 'manuales' || card.dataset.carbenGuideDocument === 'true');
          card.hidden = !matches;
          if (matches) count++;
        });
        tabs.forEach(tab => { if (tab.dataset.carbenGuideKind === selected) tab.setAttribute('aria-current', 'page'); else tab.removeAttribute('aria-current'); });
        const empty = root.querySelector('[data-carben-guide-empty]');
        if (empty) empty.hidden = count !== 0;
        const status = root.querySelector('[data-carben-guide-count]');
        if (status) status.textContent = `${count} ${count === 1 ? 'guía disponible' : 'guías disponibles'}`;
        if (updateUrl) { const url = new URL(location.href); url.searchParams.set('tipo', selected); if (input.value.trim()) url.searchParams.set('q', input.value.trim()); else url.searchParams.delete('q'); history.replaceState({}, '', url); }
      };
      form.addEventListener('submit', event => { event.preventDefault(); apply(true); });
      tabs.forEach(tab => tab.addEventListener('click', event => { event.preventDefault(); selected = tab.dataset.carbenGuideKind; apply(true); }));
      const reset = root.querySelector('[data-carben-guide-reset]');
      if (reset) reset.addEventListener('click', () => { selected = 'guias'; input.value = ''; apply(true); input.focus(); });
      apply(false);
    }
    const modelInput = root.querySelector('[data-carben-contact-model]');
    if (modelInput && !modelInput.value) modelInput.value = (new URLSearchParams(location.search).get('modelo') || '').slice(0, 200);
  }
  initializeCarbenEditorial(document);
  document.addEventListener('shopify:section:load', event => initializeCarbenEditorial(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
